import { render, staticRenderFns } from "./SavedPeople.vue?vue&type=template&id=70b03ec0&scoped=true&lang=pug&"
import script from "./SavedPeople.vue?vue&type=script&lang=js&"
export * from "./SavedPeople.vue?vue&type=script&lang=js&"
import style0 from "./SavedPeople.vue?vue&type=style&index=0&id=70b03ec0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b03ec0",
  null
  
)

export default component.exports